/* eslint-disable unicorn/filename-case */
import { ACCESS } from "@dictybase/auth-mui5"
import { About } from "../features/About/About"

// eslint-disable-next-line unicorn/prefer-export-from, import/no-default-export
export default About
export const access = ACCESS.public
